import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BookOpen, ExternalLink, FileText, LifeBuoy, LogOut, Menu } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

interface Props {
  instructionUrl?: string | null;
  regulationsTo?: string;
  regulationsLabel: string;
  onHelp?: () => void;
  onLogout: () => void;
  triggerClassName: string;
}

/** Burger menu of the collapsed sidebar footer: instruction, help, regulations and logout. */
export function SideNavMoreMenu({ instructionUrl, regulationsTo, regulationsLabel, onHelp, onLogout, triggerClassName }: Props) {
  const { t } = useTranslation();
  const label = t('nav.more');

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <button type="button" aria-label={label} title={label} className={triggerClassName}>
          <Menu className="size-4 shrink-0" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent side="right" align="end" sideOffset={8} className="min-w-52">
        {instructionUrl && (
          <DropdownMenuItem asChild className="cursor-pointer">
            <a href={instructionUrl} target="_blank" rel="noopener noreferrer">
              <FileText className="size-4 shrink-0" />
              <span>{t('nav.instruction', 'Instrukcja')}</span>
              <ExternalLink className="size-3.5 ml-auto opacity-70" />
            </a>
          </DropdownMenuItem>
        )}
        {onHelp && (
          <DropdownMenuItem className="cursor-pointer" onSelect={onHelp}>
            <LifeBuoy className="size-4 shrink-0" />
            <span>{t('nav.help', 'Pomoc')}</span>
          </DropdownMenuItem>
        )}
        {regulationsTo && (
          <DropdownMenuItem asChild className="cursor-pointer">
            <NavLink to={regulationsTo}>
              <BookOpen className="size-4 shrink-0" />
              <span>{regulationsLabel}</span>
            </NavLink>
          </DropdownMenuItem>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem variant="destructive" className="cursor-pointer" onSelect={onLogout}>
          <LogOut className="size-4 shrink-0" />
          <span>{t('nav.logout')}</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
